export const HTTP_REFETCH_INTERVAL = Number(
  import.meta.env.VITE_HTTP_REFETCH_INTERVAL || 15000
);
